import type React from "react";

import { isValidHttpUrl } from "@/lib/utils/routing/Url";

type Props = {
  children: JSX.Element | JSX.Element[] | string | null;
};

// 1. Always open external links with target="_blank" so they work from the iFrame jslib is commonly (but not always) running within
// 2. When using target="_blank", always add rel noopener noreferrer for security.
//    https://stackoverflow.com/questions/50709625/link-with-target-blank-and-rel-noopener-noreferrer-still-vulnerable
// 3. An href with any scheme other than http(s) (e.g. javascript:) is never rendered as a link;
//    only the children are shown, as MessageLink does for a disallowed protocol. An anchor with
//    no href is a plain click target and is left alone.
export const LinkExternal = ({
  children,
  href,
  ...restProps
}: Props & React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  if (href !== undefined && !isValidHttpUrl(href)) return <>{children}</>;

  return (
    <a target="_blank" rel="noopener noreferrer" href={href} {...restProps}>
      {children}
    </a>
  );
};
